import React, {Component} from 'react';
import { Button } from '@common/components/Button';
import { FixedSizeList as List } from 'react-window';
import {TestDetailsRow} from "./TestDetailstRow.jsx";
const I18n = require('react-redux-i18n').I18n;

import '../styles/GenesTable.scss';

const getGeneKey = (gene) => gene.id;

const RowRenderer = ({ index, data, style }) => {
    const row = data[index];

    return (
        <TestDetailsRow 
            key={row.id} 
            gene={row}
            allGenes={this.props.allGenes}
            classifications={this.props.classifications}
            checkGene={this.props.checkGene}
            updateGenesTableRow={this.props.updateGenesTableRow}
            parent={this.containerRef}
            style={style}
        />              
    );
  };

export default class GenesTable extends Component {

    constructor(props) {
        super(props);
        this.containerRef = React.createRef();
        this.state = {
            checkedAll: false,
        };
        this.scroll = 0;
        this.scrollTimer = null;
    }

    onDeleteRow = () => {
        this.props.onDeleteRow();

        if (this.state.checkedAll) {
            this.setState((state) => ({ ...state, checkedAll: false }));
        }
    }

    onSelectAllGenes = (e) => {
        e.persist();
        this.setState((state) => ({ ...state, checkedAll: e.target.checked }));
        this.props.checkAllGenes(e.target.checked);
    }

    renderRow = ({ index, data, style }) => {
        const row = data[index];
    
        return (
            <TestDetailsRow 
                key={row.id} 
                gene={row}
                allGenes={this.props.allGenes}
                classifications={this.props.classifications}
                checkGene={this.props.checkGene}
                updateGenesTableRow={this.props.updateGenesTableRow}
                parent={this.containerRef}
                style={style}
            />              
        );
      }

    render() {
        const { checkedAll } = this.state;
        const { genes } = this.props;
        const genesWithSomeValue = genes.filter(({ classification, gene, priorClassification, variant }) => classification || gene || priorClassification || variant);

        return (
            <div className="Genes-table">
                <table 
                    id="genes-table" 
                    className="table table-bordered table-condensed table-hover Genes-table__inner"
                >
                    <thead className="Genes-table__head">
                        <tr>
                            <th id="th-test-result0" className="Genes-table__head__cell Genes-table__cell-select">
                                <input id="cbx-th-test-result" type="checkbox" checked={checkedAll} onChange={this.onSelectAllGenes}></input>
                            </th>
                            <th id="th-test-result1" className="Genes-table__head__cell Genes-table__cell-gene" >{I18n.t('gene')}</th>
                            <th id="th-test-result2" className="Genes-table__head__cell Genes-table__cell-variant">{I18n.t('variant')}</th>
                            <th id="th-test-result3" className="Genes-table__head__cell Genes-table__cell-classification">{I18n.t('classification')}</th>
                            <th id="th-test-result4" className="Genes-table__head__cell Genes-table__cell-prior-classification">{I18n.t('priorClassification')}</th>
                        </tr>
                    </thead>
                    <List
                        height={410}
                        itemCount={genes.length}
                        itemSize={24}
                        width="100%"
                        overscanCount={5}
                        itemData={genes}
                        itemKey={getGeneKey}
                    >
                        {this.renderRow}
                    </List>
                </table>

                <div className="Genes-table__controls">
                    <Button id="btn-test-result-add-row" style={{border: 'none', fontSize: '13px', outline: 'none'}} onClick={this.props.onAddRow}>
                        <span style={{color: '#008DCE', marginRight: '3px'}}>✚</span>{I18n.t('addRow')}
                    </Button>
                    <Button id="btn-test-result-delete-row" style={{border: 'none', fontSize: '13px', outline: 'none'}} onClick={this.onDeleteRow}>
                        <span style={{color: '#008DCE', marginRight: '3px', fontWeight: 900}}>✕</span>{I18n.t('deleteRow')}
                    </Button>
                    {Boolean(genesWithSomeValue.length) && <span id="nb-test-result-count" className="Genes-table__count">{I18n.t('geneCount')}: {genesWithSomeValue.length}</span>}
                </div>
            </div>
        )
    }
}